import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getTargetList, setTargetList } from '../services';
import { SelectOptionType, SetTargetInitialStateType } from '../utils/Types';
import { API_STATUS } from '../utils/Constant';
import { handleDropOptions, isAPISuccess } from '../utils/Util';
import {
  getMasterTargetsDropValues,
  getTargetsDropValues,
} from '../services/dropDownService';

const initialState: SetTargetInitialStateType = {
  targetListData: {
    result: [],
    minTargetCount: null,
  },
  apiProgressStatus: '',
  yearOptions: [],
  seasonOptions: [],
  salesTargetOptions: [],
  productsOptions: [],
};

export const fetchTargetList = createAsyncThunk(
  'setTarget/fetchTargetList',
  async (data: any) => {
    const res = await getTargetList(data);
    return res.data;
  }
);

export const postTargetList = createAsyncThunk(
  'setTarget/postTargetList',
  async (data: any) => {
    const res = await setTargetList(data);
    return res.data;
  }
);

export const fetchTargetTypeDrops = createAsyncThunk(
  'setTarget/fetchTargetDrops',
  async (params: any) => {
    const res = await getTargetsDropValues(params);
    return res.data;
  }
);

export const fetchMasterTargetTypeDrops = createAsyncThunk(
  'setTarget/fetchMasterTargetTypeDrops',
  async () => {
    const res = await getMasterTargetsDropValues();
    return res.data;
  }
);

export const setTargetSlice = createSlice({
  name: 'setTarget',
  initialState,
  reducers: {
    clearTargetList: (state) => {
      state.targetListData.result = [];
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchTargetList.fulfilled, (state, action) => {
        if (isAPISuccess(action.payload) && action.payload.result.length) {
          state.apiProgressStatus = API_STATUS.SUCCEEDED;
          state.targetListData.result = action.payload.result;
          state.targetListData.minTargetCount =
            action.payload?.highervalue?.value;
        } else {
          state.targetListData.result = [];
          state.targetListData.minTargetCount = null;
        }
      })
      .addCase(fetchTargetList.pending, (state) => {
        state.apiProgressStatus = API_STATUS.LOADING;
      })
      .addCase(fetchTargetList.rejected, (state) => {
        state.apiProgressStatus = API_STATUS.FAILED;
        state.targetListData.result = [];
        state.targetListData.minTargetCount = null;
      })
      .addCase(fetchTargetTypeDrops.fulfilled, (state, action) => {
        if (isAPISuccess(action.payload)) {
          const result = action.payload.result;
          if (result && result.length > 0) {
            const selectOptions: SelectOptionType[] = [];
            if (action.meta.arg.module === 1 || action.meta.arg.module === 3) {
              result.forEach(
                (element: { picklistId: number; picklistName: string }) => {
                  selectOptions.push({
                    value: element.picklistId,
                    label: element.picklistName,
                  });
                }
              );
              if (action.meta.arg.module === 1) {
                state.seasonOptions = selectOptions;
              } else if (action.meta.arg.module === 3) {
                state.salesTargetOptions = selectOptions;
              }
            } else if (action.meta.arg.module === 2) {
              const latestYear = [{ ...result[result.length - 1] }];
              latestYear.forEach(
                (element: { picklistId: number; picklistName: string }) => {
                  const name = String(element.picklistName);
                  const nextYear = Number(name.substring(2, name.length)) + 1;
                  selectOptions.push({
                    value: element.picklistId,
                    label: `${name}-${nextYear}`,
                  });
                }
              );
              console.log('select options->', selectOptions);
              state.yearOptions = [...selectOptions];
            }
          }
        }
      })

      .addCase(fetchMasterTargetTypeDrops.fulfilled, (state, action) => {
        if (isAPISuccess(action.payload)) {
          const result = action.payload.result;
          if (result && Object.keys(result)?.length > 0) {
            state.seasonOptions = handleDropOptions(
              result.season,
              'seasonId',
              'seasonName'
            );
            state.salesTargetOptions = handleDropOptions(
              result.setTargetType,
              'setTargetTypeId',
              'setTargetTypeName'
            );
            state.yearOptions = handleDropOptions(
              result?.financialYear?.filter(
                (year: any) => year?.isCurrentYear
              ) || [],
              'financialYearId',
              'financialYearName'
            );
            state.productsOptions = handleDropOptions(
              result.products,
              'productId',
              'productName'
            );
          }
        }
      });
  },
});

export const targetSelector = (state: {
  setTarget: SetTargetInitialStateType;
}) => state.setTarget;

export const { clearTargetList } = setTargetSlice.actions;
export default setTargetSlice.reducer;
